import * as React from "react";
import { Grid, Card, CardContent, Typography, Box } from "@mui/material";
import DataGridDemo from "./DataGridDemo"; // Import the first table

import Sortingselecting from "./Sortingselecting"; // Import the second table
import QuickFilteringGrid from "./QuickFilteringGrid"; // Import the second table
import Breadcrumbs from "../../components/Common/Breadcrumb";
import CustomLocaleTextGrid from "./CustomLocaleTextGrid";
import HeaderFilteringDataGridPro from "./HeaderFilteringDataGridPro";

export default function TablesPage() {
  return (
    <React.Fragment>
      <div className="page-content">
        <Breadcrumbs title="Tables" breadcrumbItem="Mui Tables" />
        <Box sx={{ flexGrow: 1, padding: 2 }}>
          <Grid container spacing={2}>
            {/* First Table */}
            <Grid item xs={6}>
              <Card>
                <CardContent>
                  <Typography variant="h6" gutterBottom>
                    Data Grid Demo
                  </Typography>
                  <DataGridDemo />
                </CardContent>
              </Card>
            </Grid>

            {/* Second Table */}
            <Grid item xs={6}>
              <Card>
                <CardContent>
                  <Typography variant="h6" gutterBottom>
                  Data Grid Demo 1
                  </Typography>
                  <QuickFilteringGrid />
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        </Box>

        <Box sx={{ flexGrow: 1, padding: 2 }}>
          <Grid container spacing={2}>
            {/* Three Table */}
            <Grid item xs={6}>
              <Card>
                <CardContent>
                  <Typography variant="h6" gutterBottom>
                    Quick Filtering Grid Table
                  </Typography>
                  <HeaderFilteringDataGridPro />
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={6}>
              <Card>
                <CardContent>
                  <Typography variant="h6" gutterBottom>
                    Custom Locale Text Grid Table
                  </Typography>
                  <CustomLocaleTextGrid />
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        </Box>

        <Box sx={{ flexGrow: 1, padding: 2 }}>
          <Grid container spacing={2}>
            {/* Three Table */}
            <Grid item xs={6}>
              <Card>
                <CardContent>
                  <Typography variant="h6" gutterBottom>
                    Sorting & Selecting
                  </Typography>
                  <Sortingselecting />
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        </Box>
      </div>
    </React.Fragment>
  );
}
